import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// جلب الإعدادات من ملف .env
const API_BASE_URL = process.env.REACT_APP_API_PLAN_URL;

// 1. الأكشن الخاص بتسجيل الدخول (يستقبل البيانات بشكل طبيعي من الواجهة)
export const loginUser = createAsyncThunk(
  'auth/loginUser',
  async (credentials, { rejectWithValue }) => {
    try {
      // إرسال البيانات (userId و password) كما هي مستلمة
      const response = await axios.post(`${API_BASE_URL}auth/login`, credentials);

      // حفظ التوكن ومعلومات المستخدم في التخزين المحلي
      if (response.data.token) {
        localStorage.setItem('userToken', response.data.token);
      }
      if (response.data.user) {
        localStorage.setItem('userInfo', JSON.stringify(response.data.user)); 
      }

      return response.data;
    } catch (error) {
      console.error("Login Error:", error);
      return rejectWithValue(
        error.response?.data?.message || "فشل تسجيل الدخول، يرجى التحقق من البيانات"
      );
    }
  }
);

// استرجاع بيانات المستخدم المحفوظة عند تحميل التطبيق
const savedUser = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null;

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: savedUser,
    token: localStorage.getItem('userToken') || null,
    isAuthenticated: !!localStorage.getItem('userToken'),
    loading: false,
    error: null,
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      localStorage.removeItem('userToken');
      localStorage.removeItem('userInfo');
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = true;
        state.user = action.payload.user; 
        state.token = action.payload.token;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isAuthenticated = false;
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;